import { productEpics } from './store/product.epics';
import productReducer from './store/product.reducer';
import ProductModule from './components/ProductDetails/ProductDetails';

export { productEpics, productReducer };

export default ProductModule;
